<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>New Vehicle number  Details</strong>
                    </div>
                   
                
                <b-row>
                    <b-col>
                        <b-table
                          responsive show-empty 
                          :fields="fieldsFreight"
                          :items="vendorPendingRequest"
                          :filter="filter"
                          :busy="isBusy"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :sort-direction="sortDirection"
                          caption-top
                        >
                    <template slot="transporter_name" slot-scope="row">
                    <v-select 
                        v-model="row.item.transporter_name" 
                        :options="allTransporterVenList" 
                        label="transporter_name" 
                        placeholder="-- Select Vendor --"
                        @change="updateSelectedVendor(row.index, row.item.transporter_name)"
                        class="custom-table-close-btn"
                        ></v-select>
                    </template>                      
                      <template slot="totalloads" slot-scope="row">
                        
                        {{ row.item.totalloads }}
                    </template>
                    <template slot="freight" slot-scope="row">
                        <input v-model="row.item.freight" @input="changeFreightValue(row.index, row.item.freight)" :class="{'fa fa-star': true, 'custom-field-vendor': isStarred(row.index)}"/>
                    </template>   
                    <template slot="freightp" slot-scope="row">
                        <input v-model="row.item.freightp" :class="{'fa fa-star': true, 'custom-field-vendor': isStarred(row.index)}"/>
                    </template>
                    <template slot="createddate" slot-scope="row">
                        
                        {{ row.item.createddate }}
                    </template>

                      <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                        </b-table>

                        <b-row class="mt-3">
                          <b-col md="3">
                            <div class="mb-1">Driver First Name&nbsp;<span style="color: red;">*</span></div>
                            <b-form-input
                              id="textarea-default"
                              placeholder="Enter Driver First Name"
                              v-model.trim="driverinfo.driverfirstname"
                              :class="{ 'is-invalid': validationErrors.driverfirstname }"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="validationErrors.driverfirstname">
                              {{ firstNameErrorMessage }}
                            </b-form-invalid-feedback>
                          </b-col>
                          
                          <b-col md="3">
                            <div class="mb-1">Driver Last Name&nbsp;<span style="color: red;">*</span></div>
                            <b-form-input
                              id="textarea-default"
                              placeholder="Enter Driver Last Name"
                              v-model.trim="driverinfo.driverlasttname"
                              :class="{ 'is-invalid': validationErrors.driverlasttname }"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="validationErrors.driverlasttname">
                              {{ lastNameErrorMessage }}
                            </b-form-invalid-feedback>
                          </b-col>

                          <b-col md="3">
                            <div class="mb-1">Driver Mobile No.&nbsp;<span style="color: red;">*</span></div>
                              <b-form-input maxlength="10" type="text"
                                id="textarea-default"
                                placeholder="Enter Driver Mobile No."
                                v-model.trim="driverinfo.drivermobilenumber"
                                v-validate="'required|digits:10'"
                                :class="{ 'is-invalid': validationErrors.drivermobilenumber }"
                              ></b-form-input>
                            <b-form-invalid-feedback v-if="validationErrors.drivermobilenumber">
                              Driver mobile number is invalid.
                            </b-form-invalid-feedback>
                          </b-col>

                          <b-col sm="3">
                            <b-form-group>
                                <label for="driverslicensenumber"> Upload DL <span style="color: red;">*</span></label>
                                <b-form-file variant="primary"
                                        type="file"
                                        v-model="driverinfo.driverlicenseFile"
                                        placeholder="Upload DL" 
                                        class="custom-border"
                                        @change="driverLicenseFileUplod($event)"
                                        id="driverlicenseFile" 
                                        :class="{ 'is-invalid': validationErrors.driverlicenseFile }"
                                        name="driverlicenseFile">
                                    Upload DL
                                </b-form-file>&nbsp;
                                <b-form-invalid-feedback v-if="validationErrors.vehicle_no">
                              Vehicle number is required.
                            </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>


                          <b-col md="3">
                            <div class="mb-1">Vehicle Number&nbsp;<span style="color: red;">*</span></div>
                            <b-form-input
                              id="textarea-default"
                              placeholder="Enter Vehicle Number"
                              v-model.trim="driverinfo.vehicle_no"
                              :class="{ 'is-invalid': validationErrors.vehicle_no }"
                            ></b-form-input> &nbsp;
                            <b-form-invalid-feedback v-if="validationErrors.vehicle_no">
                              Vehicle number is required.
                            </b-form-invalid-feedback>
                          </b-col>
                          <b-col sm="3">
                            <b-form-group>
                                <label for="pucnumberfile">Upload PUC &nbsp;<span style="color: red;">*</span></label>
                                <b-form-file
                                        type="file"
                                        v-model="driverinfo.pucnumberfile"
                                        @change="pucFileUplod1($event)"
                                        id="pucnumberfile" 
                                        class="custom-border"
                                        placeholder="Upload PUC" 
                                        :class="{ 'is-invalid': validationErrors.pucnumberfile }"
                                        name="pucnumberfile">
                                    Upload PUC
                                </b-form-file>
                                &nbsp;
                                <b-form-invalid-feedback v-if="validationErrors.pucnumberfile">
                                  PUC File is required.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" class="mb-3">
                            <b-form-group>
                                <label>Upload RC <span style="color: red;">*</span></label>
                                <b-form-file
                                        placeholder="Upload RC" 
                                        class="custom-border"
                                        type="file"
                                        v-model="driverinfo.registrationfile"
                                        @change="registrationFileUplod($event)"
                                        id="registrationfile" 
                                          :class="{ 'is-invalid': validationErrors.registrationfile }"
                                        name="registrationfile">
                                    Upload RC
                                </b-form-file>
                                &nbsp;
                                <b-form-invalid-feedback v-if="validationErrors.registrationfile">
                                  RC File is required.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" class="mb-3">
                            <b-form-group>
                                <label for="permitfile">Upload Permit <span style="color: red;">*</span></label>
                                <b-form-file
                                        placeholder="Upload Permit" 
                                        type="file"
                                        class="custom-border"
                                        v-model="driverinfo.permitfile"
                                        @change="permitFileUplod($event)"
                                        id="permitfile" 
                                        :class="{ 'is-invalid': validationErrors.permitfile }"
                                        name="permitfile">
                                </b-form-file> &nbsp;
                                <b-form-invalid-feedback v-if="validationErrors.permitfile">
                                  Permit File is required.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" class="mb-3">
                            <b-form-group>
                                <label>Upload Insurance <span style="color: red;">*</span></label>
                                <b-form-file
                                        placeholder="Upload Insurance File" 
                                        type="file"
                                        class="custom-border"
                                        v-model="driverinfo.insurancefile"
                                        @change="insuranceFileUplod($event)"
                                        id="insurancefile" 
                                          :class="{ 'is-invalid': validationErrors.insurancefile }"
                                        name="insurancefile">
                                </b-form-file>
                                &nbsp;
                                <b-form-invalid-feedback v-if="validationErrors.insurancefile">
                                  Insurance File is required.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col>
                        <div sm="3" class="mb-3">
                            <b-form-group> 
                                <label>Payment Type <span style="color: red;">*</span></label>
<!-- 
                            <template v-slot:label>
                                Payment Type
                            </template> -->
                            <b-form-radio-group 
                                    v-model="driverinfo.paymenttype" 
                                    :options="[
                                        { text: 'Daily', value: 'tripend' }, 
                                        { text: 'Weekly', value: 'weekly' },
                                        { text: 'Monthly', value: 'monthly' }
                                    ]"
                                    name="paymenttype"
                                >
                                </b-form-radio-group>
                                &nbsp;
                                <b-form-invalid-feedback v-if="validationErrors.paymenttype">
                                  Payment Type is required.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </b-col>
                          <!-- <b-col md="3" class="mb-3">
                                  <div >Labor Charges *&nbsp;
                                  <b-form-group label="" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="text" id="laborCharges" name="laborCharges" v-model="driverinfo.labour_charges" placeholder="Enter Labor Charges"></b-form-input>
                                  </b-input-group>
                                  </b-form-group>
                                </div>
                              </b-col>
                              <br> -->
                                <!-- <b-col md="3" class="mb-3">
                                  <div >Fixed KM's *&nbsp;
                                  <b-form-group label="" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="text" id="fixedkm" name="fixedkm" v-model="driverinfo.fixed_kms" placeholder="Enter Fixed km's"></b-form-input>
                                  </b-input-group>
                                  </b-form-group>
                                </div>
                              </b-col>
                                <b-col md="3" class="mb-3" >
                                  <div >Fixed Freight rate&nbsp;
                                  <b-form-group label="" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="text" id="fixedkmrate" name="fixedkmrate" v-model="driverinfo.fixed_freightrate" placeholder="Enter Fixed rate"></b-form-input>
                                  </b-input-group>
                                  </b-form-group>
                                </div>
                            </b-col>
                            <b-col md="3" class="mb-3">
                              <div >Extra KM rate&nbsp;
                                  <b-form-group label="" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="text" id="extrakm" name="extrakm" v-model="driverinfo.extra_kmrate" placeholder="Enter Extra km's rate"></b-form-input>
                                  </b-input-group>
                                  </b-form-group>
                                </div>

                              </b-col>
                                  <b-col md="3" class="mb-3">
                                    <div >Working days&nbsp;

                                  <b-form-group label="" label-align="left">
                                  <b-input-group>
                                      <b-form-input class="input" type="text" id="workingday" name="workingday" v-model="driverinfo.workingdays" placeholder="Enter Working Day"></b-form-input>
                                  </b-input-group>
                                  </b-form-group>  
                                </div>                
                            </b-col> -->
                        
                            <!-- <b-col md="3">
                            
                              <b-form-group> 
                                <div > Payment Type&nbsp;
                               
                                <b-form-radio-group 
                                        v-model="driverinfo.paymenttype" 
                                        v-validate="'required'"
                                        :options="[
                                            { text: 'Daily', value: 'tripend' }, 
                                            { text: 'Weekly', value: 'weekly' },
                                            { text: 'Monthly', value: 'monthly' }
                                        ]"
                                        name="paymenttype"
                                    >
                                    </b-form-radio-group>
                                  </div>
                              </b-form-group>
                            
                            </b-col> -->

                          <b-col md="4" class="text-center">
                            <div class="mb-3"></div>
                            <b-button
                              variant="primary"
                              @click.prevent="submitNewVehicleDetails"
                              :disabled="isFormInvalid"
                            >
                              Save
                            </b-button>&nbsp;
                            <b-button variant="primary" @click="redirectToDestination">Cancel</b-button>&nbsp;
                          </b-col>
                        </b-row>



                    </b-col>
                </b-row>
                    
               
                </b-card>
               
            </b-col>
        </b-row>

    </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Swal from 'sweetalert2';
const axios = require('axios')

export default {
  data() {
    return {
      requestId: null,  // Initialize to store the route param
      fields : [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'totalloads', label : 'Total Loads', sortable: true},
                { key : 'totalmps', label : 'Total MPS', sortable: true},
                { key : 'totalvolwt', label : 'Total Vol. Wt(Tonn)', sortable: true},
                { key : 'lastmodifiedby', label : 'Last modified By & On', sortable: true},
                { key : 'createddate', label : 'Request Date', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'basefreight', label : 'Base Freight', sortable: true},
                { key : 'invoicevalue', label : 'Invoice Value', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'delivery_locations', label : 'Destination', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true}
        ],
        fieldsFreight: [ 
        { key: "requestid", label: "Request ID" , sortable: true},
        { key: "createddate", label: "Request Date" , sortable: true},
        { key: "origin", label: "Origin" , sortable: true},
        { key: "totalloads", label: "Load Count" , sortable: true},
        { key: "vehicle_size", label: "Vehicle Size Requested" , sortable: true},
        { key: "totalvolwt", label: "Load. Vol. Wt.(Tonn)" , sortable: true},
        { key: "totalphysicalwt", label: "Total Physical Weight(KGs)" , sortable: true},
        { key: "delivery_locations", label: "Destination" , sortable: true},
        { key: "delivery_points", label: "Delivery Points" , sortable: true},
        ],
        vendorPendingRequest: [],
        vendorInfoList:[],
        selected_vendor: '',
        vendorNameList: [],
        vendorname: null,
        filter: "",
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      selected_vendor_table: '',
      allTransporterVenList: [],
      updateInfo:false,
      addVendorDetails: {
        vendorCompanyName: '',
        vendorMobileNo: '',
        vendorEmailId: '',
        addFreight: ''
      },
      errors: {
        vendorCompanyName: null,
        vendorMobileNo: null,
        vendorEmailId: null,
        addFreight: null,
      },
      starredItems: [], // Array to keep track of which rows have a starred icon
      starredRows: [], // Array to store the indexes of starred rows
      suggestionFields: [ 
        { key: "createddate", label: "Log Date & Time", sortable: true },
        { key: "createdby", label: "Log Updated By", sortable: true },
        { key: "logtype", label: "Log Type", sortable: true },
        { key: "vendor_suggested", label: "Vendor Suggested", sortable: true },
        { key: "reason", label: "Reason", sortable: true },
        { key: "comment", label: "Comment", sortable: true },
        ],
      getAllSuggestionList: [],
      showDeleteIcon: 0,
      selectcsvFile: "",
      file: "",
      selectFiletype: "",
      acceptedloads: [],
      driverinfo: {
        driverfirstname: '',
        driverlasttname: '',
        drivermobilenumber: '',
        vehicle_no: ''
      },
      validationErrors: {
        driverfirstname: false,
        driverlasttname: false,
        drivermobilenumber: false,
        vehicle_no: false
      },
      firstNameErrorMessage: '',
      lastNameErrorMessage: '',
      currentBidID: 0,
      dlFileName: '',
      dlFileType: '',
      selectedDl: '',
      licence_url:'',
      pucFileUplodFilename: '',
      pucFileUplod: '',
      pucFileUplodType: '',
      puc_url:'',
      selectedRegistration: '',
      registrationFilename: '',
      registrationFileType: '',
      registration_url: '',
      selectedPermit : '',
      permitFileName: '',
      permitFileType: '',
      permit_url: '',
      selectedInsuranceFile: '',
      insurance_url: ''
    };
  },
  computed: {
    isFormInvalid() {
      const nameRegex = /^[A-Za-z\s]+$/;
      return (
        !nameRegex.test(this.driverinfo.driverfirstname.trim()) ||
        !nameRegex.test(this.driverinfo.driverlasttname.trim()) ||
        !/^\d{10}$/.test(this.driverinfo.drivermobilenumber.trim()) || // Example regex for mobile number
        this.driverinfo.vehicle_no.trim() === '' ||
        !this.driverinfo.paymenttype ||
        !this.driverinfo.insurancefile  ||
        !this.driverinfo.permitfile  ||
        !this.driverinfo.registrationfile ||
        !this.driverinfo.pucnumberfile ||
        !this.driverinfo.driverlicenseFile
      );
    }
  },  
  created() {
    // Access the dynamic 'id' from the route params
    this.requestId = this.$route.params.id;
    this.fetchAllFreightList(this.$route.params.id),
    this.allVendorList();
    this.allTransporterVendorList();
    this.getAllSuggestion();
    this.approveFreightAndVendorRequest()
  },

  watch: {
    'driverinfo.driverfirstname'(value) {
      const nameRegex = /^[A-Za-z\s]+$/;
      if (!nameRegex.test(value.trim())) {
        this.validationErrors.driverfirstname = true;
        this.firstNameErrorMessage = 'Numbers are not allowed in the first name.';
      } else {
        this.validationErrors.driverfirstname = false;
        this.firstNameErrorMessage = '';
      }
    },
    'driverinfo.driverlasttname'(value) {
      const nameRegex = /^[A-Za-z\s]+$/;
      if (!nameRegex.test(value.trim())) {
        this.validationErrors.driverlasttname = true;
        this.lastNameErrorMessage = 'Numbers are not allowed in the last name.';
      } else {
        this.validationErrors.driverlasttname = false;
        this.lastNameErrorMessage = '';
      }
    },
    'driverinfo.drivermobilenumber'(value) {
      this.validationErrors.drivermobilenumber = !/^\d{10}$/.test(value.trim());
    },
    'driverinfo.vehicle_no'(value) {
      this.validationErrors.vehicle_no = value.trim() === '';
    }
  },

  methods: {
    redirectToDestination(){
      this.$router.push({ path: '/adhocpendingrequest' });
    },
   
    approveFreightAndVendorRequest() {

      if (this.$route && this.$route.params && this.$route.params.id === 2) {
            this.approveALLRequest()
        }
    },

    approveALLRequest(type,value){

      // return false;

      let tableRows = '';
            if (type==='checkAll') {
                this.selectapproverequest.forEach(plan => {
                    tableRows += `
                    <tr>
                        <td>${plan.origin}</td>
                        <td>${plan.route}</td>
                        <td>${plan.vehicle_size}</td>
                        <td>${plan.createdby}</td>
                    </tr>
                    `;
                });
            }
             if (type==='table') {
                this.selectrequestid = [];
                this.selectapproverequest =[];
                this.isCheckAll = false;
                let approvearray = [];
                approvearray.push(value)
               

                approvearray.forEach(plan => {
                    tableRows += `
                    <tr>
                        <td>${plan.origin}</td>
                        <td>${plan.route}</td>
                        <td>${plan.vehicle_size}</td>
                        <td>${plan.createdby}</td>
                    </tr>
                    `;
                });
            }
            

            Swal.fire({
                title: "<h3>Confirm Approval</h3><hr>",
                html: `
                    Please confirm the approval of the below adhoc plans.
                    <br/><br/>
                    <table border="1" cellpadding="5" cellspacing="0" style="width:100%; text-align: left;">
                        <thead>
                        <tr>
                            <th>Origin</th>
                            <th>Route</th>
                            <th>Vehicle Size</th>
                            <th>Request By</th>
                        </tr>
                        </thead>
                        <tbody>
                        ${tableRows}
                        </tbody>
                    </table>
                `,
                showCancelButton: true,
                confirmButtonText: "Confirm",
                confirmButtonColor: "#00c0ef",
                cancelButtonText: "Close",
                cancelButtonColor: "#F8943F",
            }).then((result) => {

              // if (result.isConfirmed) {
                if (result.value) {
                    this.loader=true;;
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);
               
                    const obj = {
                        // requestid:1,
                        // bidid: 31,
                        requestid: this.requestId,
                        bidid: this.currentBidID ? this.currentBidID : null,
                        createdby:userInfo.userfirstname + userInfo.userlastname,
                        sysusermasterid: `${userInfo.sysusermasterid}`,
                        reason: null
                    }

                    this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/approveAdhocRequests`,obj).then(result => {
                        this.loader=false;
                        if (result.body.returnmsg == "Successful") {
                            this.$fire({
                            text: "Request Approved Successfully!",
                            type: "success",
                            timer: 300000,
                            });
                            this.selectrequestid = [];
                            this.isCheckAll = false;
                            this.selectapproverequest = [];
                            this.getPendingList(1);
                        } else {
                            this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 300000,
                            });
                        }
                    })
                    .catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle cancel action
                    Swal.fire(
                        'Cancelled',
                        'Your action has been cancelled',
                        'error'
                    );
                }
                return false;
            })
            // row.item.requestid
    },

    reconsiderRequest(value) {
            this.selectrequestid = [];
            this.selectapproverequest = [];
            this.isCheckAll = false;

            Swal.fire({
                title: "<h3>Request Reconsider</h3><hr>",
                html: `
                Please enter the reason for Reconsider.
                <br/><br/>
                <div style="display: flex; justify-content: space-around; align-items: center;">
                    <label for="reason" style="margin-right: 10px;"><strong>Reason:</strong></label>
                    <textarea id="reason" rows="4" style="width: 70%;"></textarea>
                </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Submit",
                confirmButtonColor: "#00c0ef",
                cancelButtonText: "Close",
                cancelButtonColor: "#F8943F",
                preConfirm: () => {
                    const reason = document.getElementById('reason').value;
                    if (!reason) {
                        Swal.showValidationMessage('Please enter a reason');
                    }
                    return { reason: reason };
                }
            }).then((result) => {
                // if (result.isConfirmed) {
                  if (result.value) {
                    this.loader = true;
                    var userdata = localStorage.getItem("userData");
                    var userInfo = JSON.parse(userdata);

                    const obj = {
                        // requestid: 1,
                        // bidid: 27,
                        requestid: this.requestId,
                        bidid: this.currentBidID ? this.currentBidID : null,
                        createdby: userInfo.userfirstname + " " + userInfo.userlastname,
                        // sysusermasterid: userInfo.sysusermasterid,
                        sysusermasterid: `${userInfo.sysusermasterid}`,
                        reason: result.value.reason,  // Use result.value.reason here
                    };

                    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/markVendorReconsiderForRequest`, obj).then(result => {
                        this.loader = false;
                        if (result.body.returnmsg === "Successful") {
                            this.$fire({
                                text: "Request Successfully Rejected!",
                                type: "success",
                                timer: 3000,
                            });
                            this.selectrequestid = [];
                            this.isCheckAll = false;
                            this.selectapproverequest = [];
                            this.getPendingList(1);
                        } else {
                            this.$fire({
                                text: result.body.returnvalue,
                                type: "error",
                                timer: 3000,
                            });
                        }
                    }).catch((ex) => {
                        console.log("error", ex);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    // Handle cancel action
                    Swal.fire(
                        'Cancelled',
                        'Your action has been cancelled',
                        'error'
                    );
                }
                return false;
            });
        },

    searchVendoraName(requestId, vendorname) {

      if(vendorname==null){
            this.selected_vendor="";
            this.fetchAllFreightList();
        } else {
            this.fetchAllFreightList(requestId, vendorname);
        }
    },

    fetchAllFreightList(requestId, vendorname) {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                // requestid: requestId,
                requestid: requestId,
                // vendorid: `${userInfo.sysusermasterid}`
                vendorid: vendorname ? vendorname : null
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/adhocVendorFreightList`,obj).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.vendorPendingRequest = result.body.returnvalue;
                    this.vendor_pending_count = this.vendorPendingRequest.length;
                    this.vendorInfoList = result.body.vendorinfo;

                  } else {

                    this.vendor_pending_count = 0;
                    this.vendorPendingRequest = [];
                    this.vendorInfoList = []
                }
            })
            .catch((ex) => {
                console.log('in catch block');
                Swal.fire({
                    title:ex,
                    icon: "error",
                });
            });
    },

    // get vendor list of transpoter is already created
    allVendorList() {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                requestid: this.requestId,
                type: null
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRegisteredVendorsList`,obj).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.vendorNameList = result.body.returnvalue.map(item => ({
                                    transporter_name: item.transporter_name,
                                    vendorid: item.transporter_id
                                }));

                              } else {
                    this.vendorNameList = []
                }
            })
              .catch((ex) => {
                  console.log("error", ex);
                  Swal.fire({
                title:ex,
                icon: "error",
              });
            });
    },

    addFreight() {
        this.vendorInfoList.push({
        basefreight: "50000.00",
        transporter_name: "",
        freight: "",
        freightp: "",
        showDeleteIcon: 1
      });
     
    },
    
    removeFreightDetails(index) {

      this.vendorInfoList.splice(index, 1);
    },

    updateSelectedVendor(index, selectedVendor) {
      // Handle the vendor selection change if needed
      console.log(`Selected vendor for index ${index}: ${selectedVendor}`);
    },

    changeFreightValue(index, freightValue) {
        // Add 10 to the freight value and update freightp
        const freightNumber = freightValue;
        if (!isNaN(freightNumber)) {
            this.vendorInfoList[index].freightp = freightNumber + 10; // Update freightp
            console.log(this.vendorInfoList, 'this.vendorInfoList@@@@111');
        } else {
            this.vendorInfoList[index].freightp = ""; // Clear if input is invalid
        }
    },

    // add vendon for table
    allTransporterVendorList() {
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                requestid: 1,
                type: 'addvendor'
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRegisteredVendorsList`,obj).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log(result.body, 'aaaaaa');
                    // return false;
                    this.allTransporterVenList = result.body.returnvalue.map(item => ({
                                    transporter_name: item.transporter_name,
                                    vendorid: item.transporter_id
                                }));
                } else {
                    this.allTransporterVenList = []
                }
            })
            .catch((ex) => {
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    // add new freight
    addFreightInfirmation(transportername, freight) {
        console.log('transportername', 'transportername', transportername)
        console.log(this.allTransporterVenList, 'this.allTransporterVenList')
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const vendorInfo = this.allTransporterVenList.find(item => item.transporter_name === transportername.transporter_name)
            console.log(vendorInfo, 'vendorInfovendorInfo')
            let vendirid = null
            if (vendorInfo) {
                vendirid = vendorInfo.vendorid
            } else {
                vendirid = null
            }
            
            const freightInfo = {
                requestid: 1,
                vendorid: vendirid,
                freight: freight,
                createdby: userInfo.userfirstname + " " + userInfo.userlastname,
            };
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/addFreightForRequest`,freightInfo).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnvalue,
                        icon: "error",
                    });
                    this.fetchAllFreightList();
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    // add vendor
    addVendor() {
        this.updateInfo = !this.updateInfo; 
    },

    // submitVendor 

    submitvenodr() {
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const vendorDetail = {
              companyname: this.addVendorDetails.vendorCompanyName,
              emailid: this.addVendorDetails.vendorEmailId,
              mobileno: this.addVendorDetails.vendorMobileNo,
              freight: this.addVendorDetails.addFreight,             
              createdby: userInfo.userfirstname + " " + userInfo.userlastname,
              requestid: 1,
              registered_from:'Admin_Portal_TM'	
            };
            // console.log(vendorDetail, 'vendorDetail')
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/addVendorForAdhocVehicleRequest`,vendorDetail).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnmsg,
                        icon: "success",
                    });
                    this.updateInfo = !this.updateInfo; 
                    this.fetchAllFreightList();
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },


    // upload csv

    uploadcsvFile: function(event) {
      this.selectcsvFile = event.target.files[0];
        
      this.selectFiletype = event.target.files[0].type;
      
      console.log("selectFiletype", this.selectFiletype);
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
        if (this.selectFiletype == "text/csv") {
          let data = new FormData();
          data.append("file", this.selectcsvFile);
          // data.append("file", csvFile);
          data.append(
            "requestid",
            10
          );
          data.append("createdby", userInfo.userfirstname + " " + userInfo.userlastname);
          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };
          console.log("Config", config);
          // return false;
          this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addVendorsForAdhocVehicleRequestViaCsv`, data, {
              header: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((result) => {
              console.log("YYY", result);
              document.getElementById("overlay").style.display = "none";
              this.resultMsg = result.body.returnmsg;
              if (result.body.returnmsg === "Successful") {
                // alert("inn");
                this.$fire({
                  text: result.body.returnvalue,
                  type: "success",
                  timer: 30000,
                });
                // this.uploadcsvfilelisting(this.pageNum);

               
                var addzone = document.getElementById("addzone");
                addzone.style.display = "none";

                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
                var showerror = document.getElementById("showerror");
                showerror.style.display = "block";
              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
                this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
              }
            })
            .catch((ex) => {
              document.getElementById("overlay").style.display = "none";
              console.log("error", ex);
              csvFile = '';
              this.selectcsvFile = "";
                this.selectFiletype = "";
                this.file = "";
            });
        } else {
          document.getElementById("overlay").style.display = "none";
          this.$fire({
            text: "Please Upload CSV File Only",
            type: "error",
            timer: 30000,
          });
          csvFile = '';
        }
    },

    // suggestion

    toggleStar(index) {
      const rowIndex = this.starredRows.indexOf(index);
      if (rowIndex === -1) {
        // Add index to starredRows if not already present
        this.starredRows.push(index);
      } else {
        // Remove index from starredRows if already present
        this.starredRows.splice(rowIndex, 1);
      }
    },
    isStarred(index) {
      return this.starredRows.includes(index); // Check if the row is starred
    },

    // submit suggestion
    submitSuggestion () {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const markSuggestion = {
                  // requestid: 1,
                  // bidid: 22,
                  requestid: this.requestId,
                  bidid: this.currentBidID ? this.currentBidID : null,
                  reason: this.suggested_reason,
                  comment: this.comment,
                  createdby: userInfo.userfirstname + " " + userInfo.userlastname,
                  sysusermasterid: `${userInfo.sysusermasterid}`
            };

            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/markVendorAsSuggestion`,markSuggestion).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log('when succsessful');
                    Swal.fire({
                        title:result.body.returnmsg,
                        icon: "success",
                    }); 
                    this.fetchAllFreightList();
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log('in catch add block')
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },
    

    // get all suggestion here
    getAllSuggestion() {
      console.log('ok to vendor list')
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);


            const obj = {
                requestid: 1,
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getRequestLogs`,obj).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    console.log(result.body, 'aaaaaa');
                    // return false;

                    this.getAllSuggestionList = result.body.returnvalue
                } else {
                    this.getAllSuggestionList = []
                }
            })
            .catch((ex) => {
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },

    //add new Vehicle Details
    submitNewVehicleDetails() {
      // console.log('new Vehicle Details')
      // return false;
      if (this.isFormInvalid) {
        return; // Prevent submission if the form is invalid
      }
        document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const infoResult = this.vendorInfoList.find(item => item.suggested_vendor === 'Yes')
            const submitvehicle = {
                        transporter_id: infoResult && infoResult.vendorid ? infoResult.vendorid : null,
                        driverfirstname: this.driverinfo.driverfirstname,
                        driverLastName: this.driverinfo.driverlasttname,
                        drivermobilenumber: this.driverinfo.drivermobilenumber,
                        vehicle_no: this.driverinfo.vehicle_no,
                        lastmodifiedby: userInfo.userfirstname + userInfo.userlastname,
                        requestid: this.requestId ,
                        sysusermasterid: `${userInfo.sysusermasterid}`,
                        registration_url: this.registration_url ? this.registration_url: '',
                        puc_url: this.puc_url? this.puc_url: '',
                        insurance_url: this.insurance_url ? this.insurance_url : '',
                        permit_url:this.permit_url ? this.permit_url : '',
                        paymenttype: this.driverinfo.paymenttype ? this.driverinfo.paymenttype : '',
                        licence_url: this.licence_url ? this.licence_url : ''  
                        // labour_charges: this.driverinfo.labour_charges,
                        // fixed_kms:this.driverinfo.fixed_kms,
                        // fixed_freightrate:this.driverinfo.fixed_freightrate,
                        // extra_kmrate:this.driverinfo.extra_kmrate,
                        // workingdays: this.driverinfo.workingdays
            };

            // console.log(submitvehicle, 'submitvehicle@@', this.driverinfo);
            // return false;
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/createNewVehicleForAdhocRequest`,submitvehicle).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    Swal.fire({
                        title:result.body.returnmsg,
                        icon: "success",
                    }); 
                    this.driverinfo.driverfirstname = '';
                    this.driverinfo.driverlasttname = '';
                    this.driverinfo.drivermobilenumber = '';
                    this.driverinfo.vehicle_no = ''
                    this.driverinfo.driverlicenseFile = ''
                    this.driverinfo.pucnumberfile = '';
                    this.driverinfo.registrationfile = '';
                    this.driverinfo.permitfile = '';
                    this.driverinfo.insurancefile = '';
                    this.driverinfo.paymenttype = '';
                } else {
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })                  
                    
                }
            })
            .catch((ex) => {
                console.log("error", ex);
                Swal.fire({
              title:ex,
              icon: "error",
            });
            });
    },


    // validation start here

    // Validation methods
    validateCompanyName() {

      if (!this.addVendorDetails.vendorCompanyName) {
        this.errors.vendorCompanyName = 'Company name is required';
      } else {
        this.errors.vendorCompanyName = null;
      }
    },

    validateMobileNo() {
      const mobilePattern = /^[0-9]{10,12}$/;
      if (!mobilePattern.test(this.addVendorDetails.vendorMobileNo)) {
        this.errors.vendorMobileNo = 'Please enter a valid mobile number';
      } else {
        this.errors.vendorMobileNo = null;
      }
    },

    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.addVendorDetails.vendorEmailId)) {
        this.errors.vendorEmailId = 'Please enter a valid email address';
      } else {
        this.errors.vendorEmailId = null;
      }
    },
    
    validateFreight() {
      if (!this.addVendorDetails.addFreight || isNaN(this.addVendorDetails.addFreight)) {
        this.errors.addFreight = 'Freight should be a valid number';
      } else {
        this.errors.addFreight = null;
      }
    },

      
    driverLicenseFileUplod(event){
            this.selectedDl= event.target.files[0];            
            if (this.selectedDl) {
                this.dlFileName = `${event.target.files[0].name}`; 
            }
            this.dlFileType = this.selectedDl.type;
            this.uploadDL(this.selectedDl);
        },
        uploadDL : function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedDl)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.licence_url=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In licence check',e);
                
            })
        
        },
        pucFileUplod1(event){
            this.pucFileUplod = event.target.files[0];            
            if (this.pucFileUplod) {
                this.pucFileUplodFilename = `${event.target.files[0].name}`; 
            }
            this.pucFileUplodType = this.pucFileUplod.type;
            this.uploadPuc(this.pucFileUplod);

        },
        uploadPuc : function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.pucFileUplod)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.puc_url=response.data.image_url;
                                        
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Bank check',e);
                
            })
        
        },
        
        registrationFileUplod(event){
            this.selectedRegistration= event.target.files[0];            
            if (this.selectedRegistration) {
                this.registrationFilename = `${event.target.files[0].name}`; 
            }
            this.registrationFileType = this.selectedRegistration.type;
            this.uploadRegisterFile(this.selectedRegistration);

        },
        uploadRegisterFile : function () {
        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedRegistration)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.registration_url=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload register certificate',e);
                
            })
        
        },
        insuranceFileUplod(event){
            this.selectedInsuranceFile= event.target.files[0];            
            if (this.selectedInsuranceFile) {
                this.registrationFilename = `${event.target.files[0].name}`; 
            }
            this.registrationFileType = this.selectedInsuranceFile.type;
            this.uploadInsuranceFile(this.selectedInsuranceFile);

        },
        uploadInsuranceFile:  function () {
        var userData = localStorage.getItem('userData');
        var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedInsuranceFile)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.insurance_url=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error in upload register certificate',e);
                
            })
        
        },
        permitFileUplod(event){ 
            this.selectedPermit= event.target.files[0];            
            if (this.selectedPermit) {
                this.permitFileName = `${event.target.files[0].name}`; 
            }
            this.permitFileType = this.selectedPermit.type;
            this.uploadPermitFile(this.selectedPermit);
        },
        uploadPermitFile : function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData);

            let data = new FormData();
            data.append('file', this.selectedPermit)
            axios.post(`${CONSTANTS.MIGRATION_API_URL}/uploadfiletos3`,data, 
                {
                    header : { 'Content-Type' : 'multipart/form-data'
                    }, 
                })
            .then(response => {
                if (response.data.result=='success') {
                    this.$fire({
                        text:"File Uploaded",
                        type: "success",
                        timer: 300000
                    })
                    this.permit_url=response.data.image_url;                    
                } else {
                    this.$fire({
                        text:"File Not Uploaded",
                        type: "error",
                        timer: 300000
                    })
                }
            })
            .catch(e => {
                console.log('Error In Upload Permit File',e);
                
            })
        
        }
  }
}

</script>

<style scoped>
.tab-content {
margin-top: 20px;
}

.nav-link {
    color: #6c757d;  /* Customize the text color */
    background-color: #f8f9fa; /* Customize the background */
    border-color: #dee2e6;    
}
.tabs .nav-tabs {
    display: flex;
    justify-content: center; /* Centers the tabs horizontally */
    align-items: center; /* Centers the content vertically */
}


.custom-outer-filter {
    padding-top: 25px;
    padding-left: 15px;
}


.cutom-view-all-btn {
border: none !important;
border-radius: 10px !important;
/* margin-left: 15px !important; */
background-color: #E8E4E4 !important;
padding: 4px !important;
}

.cutom-view-all-btn:focus {
border: none !important;
border-radius: 10px !important;
/* margin-left: 15px !important; */
outline: none !important;
background-color: #E8E4E4 !important;
box-shadow: none !important;
padding: 4px !important;
}

.nav-link {
    background: #66635BAD !important;
    border-radius: 10px !important;
    margin-bottom: 20px;
  }
  .nav-link.active {
    background-color: #66635BAD !important;
    background: #00BDF0 !important;
    margin-bottom: 20px;
}


.nav-link {
        background: #7B7B7B !important;
        border-radius: 20px;
        border: none;
    }
    .nav-link.active {
        background: #F8943F !important;
    border-radius: 20px;
    border: none;
  }

  .nav-tabs {
    border-bottom: none !important;
}

.custom-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.custom-link i {
    font-size: 24px; /* Adjust icon size */
    margin-bottom: 5px; /* Add space between icon and text */
    color: #fff; /* Set icon color to white */
}

.custom-link div {
    font-size: 16px; /* Adjust text size */
    color: #fff !important;
}
.cutom-view-plan-btn {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}
.cutom-view-plan-btn:focus {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}

.modal-center-title .modal-header {
    justify-content: center;
    width: 100%;
}

.modal-center-title .modal-title {
    text-align: center;
    width: 100%;
}
.custom-Freight-lowest-price {
    background-color: #C0EA47 !important;
    color: 000 !important;
    padding: 5px !important;
    border: none !important;
}
.custom-Freight-lowest-price:focus {
    background-color: #C0EA47 !important;
    color: 000 !important;
    padding: 5px !important;
    border: none !important;
    outline: none !important;
}
.custom-field-vendor {
  background-color: #C0EA47 !important;
    color: 000 !important;
}
.custom-table-icon {
  background: none !important;
  border: none !important;
  outline: none;
}
.custom-table-icon:focus {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.custom-table-icon:active{
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.custom-table-close-btn .clear {
    /* Add your styles here */
    background: none !important;
    background-color: none !important;
    color: #b0c4de !important;
}
.custom-border label{
    overflow: hidden !important;
    line-height: 22px !important;
}

</style>